<template>
  <div class="scan-code-bg"></div>
</template>

<script>
import { postlogin4AApi, getLoginUser, getUserProjects } from "@/api/api";

export default {
  name: "scanCode",
  components: {},
  data() {
    return {};
  },
  methods: {
    init() {
      let data = {
        corpId: this.$route.query.appid,
        code: this.$route.query.code,
        corpSecret: process.env.VUE_APP_CORPSECRET,
      };
      postlogin4AApi(data)
        .then((res) => {
          let { code, data } = res.data;
          console.log(code, res.data.message);
          if (code == 200) {
            $cutscenes.continuation();
            localStorage.removeItem("getPhoneCodeTime");
            this.$notify({
              title: "扫码成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.storeProjects();
          } else {
            this.$notify({
              title: res.data.message,
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
            this.$router.push({
              path: "/login",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$router.push({
            path: "/login",
          });
        });
    },

    async storeProjects() {
      await getLoginUser({
        appType: 1,
      }).then((resL) => {
        if (resL.data.success && resL.data.data) {
          //let loginAccount=resL.data.data.account; //存放用户账户名。
          let loginAccount = resL.data.data.name; //（改为）存放用户真实姓名。
          if (loginAccount) {
            window.sessionStorage.setItem("loginAccount", loginAccount);
            window.sessionStorage.setItem(
              "posCode",
              resL.data.data.loginEmpInfo.positions[0].posCode
            );
          }
        }
      });
      getUserProjects().then((res2) => {
        if (res2.data.data && res2.data.data.length > 0) {
          let projectInfoArr = res2.data.data;
          //综合考虑，这里暂时用sessionStorage来存储项目列表数据。

          // 使 单项目账号 进入项目列表页时遍历数组不出错。
          if (projectInfoArr.length === 1) {
            projectInfoArr = [...projectInfoArr];
          }

          window.sessionStorage.setItem(
            "projectInfoArrJson",
            JSON.stringify(this.unique(projectInfoArr, "id"))
          );

          this.$router.push({
            path: "/projectsList",
          });
        } else {
          this.$message.error("此账号下暂时没有可以查看的项目，请联系我们!");
          return false;
        }
      });
    },

    //数组去重
    unique(arr, key) {
      let map = new Map();
      arr.forEach((item, index) => {
        if (!map.has(item[key])) {
          map.set(item[key], item);
        }
      });
      return [...map.values()];
    },
  },
  mounted() {
    // this.corpId = this.$route.query.appid;
    // this.code = this.$route.query.code;
    // this.state = this.$route.query.state;
    this.init();
  },
};
</script>
<style>
.scan-code-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
}
</style>
